
import Vue from 'vue';

export default Vue.extend({
  name: 'DetailDialog',
  props: {
    payload: { type: Object, required: true },
  },
  data: () => ({
    localDialog: false,
  }),
});
